import { Transition } from "@headlessui/react";
import { debounce } from "lodash";
import React, { Fragment, useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";

type valueType = number | string | { name: string; value: any };

interface props {
  label: string;
  id: string;
  name: string;
  values: number[] | string[] | { name: string; value: any }[];
  setvalues: (value: any) => void;
  loading: boolean;
  errorMsg?: string;
}

export default function AsyncMultiSelect({
  id,
  label,
  name,
  values,
  setvalues,
  loading,
  errorMsg,
}: props) {
  const inputRef = useRef<HTMLInputElement>();
  const [internalValues, setInternalValues] = useState(values ?? []);
  const [show, setshow] = useState(false);

  function openModal() {
    setshow(true);
  }
  function closeModal() {
    setshow(false);
  }

  function addValue() {
    if (inputRef.current.value) {
      const newValues = [...internalValues] as any[];
      newValues.push(inputRef.current.value);
      setInternalValues(newValues);
      inputRef.current.value = "";
    }
  }

  function removeValue(index: number) {
    const newValues = [...internalValues] as any[];
    setInternalValues(newValues.filter((_x, i) => i !== index));
  }

  useEffect(() => {
    document.querySelectorAll("yourDropdownContainer").forEach((ele) => {
      ele.addEventListener("blur", (e) => {
        // @ts-ignore
        if (!e.currentTarget.contains(e.relatedTarget)) {
          // @ts-ignore
          setshow(false);
        }
      });
    });
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <div className="relative flex flex-col w-full gap-3">
        <label htmlFor={id}>{label}</label>
        <div className="relative flex h-10">
          <input
            ref={inputRef}
            id={id}
            name={name}
            type="search"
            className="border bg-transparent pl-2 pr-12 w-full"
            onChange={() => debounce(openModal, 1000)}
          />
          <button
            onClick={addValue}
            className="text-4xl bg-gray-300 bg-opacity-25 hover:bg-opacity-50 hover:text-red-500 absolute right-[2px] px-2"
          >
            &#43;
          </button>
        </div>

        <Transition
          as={Fragment}
          show={true}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <div
            id={"yourDropdownContainer"}
            className="absolute -bottom-14 w-[90%] flex bg-white shadow-xl border rounded-md mx-2 py-2"
          >
            <span>
              <button>hello</button>
            </span>
          </div>
        </Transition>
      </div>
      {Array.isArray(internalValues) && internalValues.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {internalValues.map((x, i) => (
            <div
              key={i}
              className="bg-gray-100 min-w-[10rem] flex justify-between items-center rounded-md overflow-hidden"
            >
              {typeof x === "number" || typeof x === "string" ? (
                <span className="pl-2">{x}</span>
              ) : (
                <span className="pl-2">{x.name}</span>
              )}
              <button
                className="hover:text-red-500 text-2xl hover:bg-gray-300 hover:bg-opacity-50 px-2 "
                onClick={() => removeValue(i)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
